import { render, staticRenderFns } from "./Dialog.vue?vue&type=template&id=5d9b1c48"
import script from "./Dialog.vue?vue&type=script&lang=js"
export * from "./Dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d9b1c48')) {
      api.createRecord('5d9b1c48', component.options)
    } else {
      api.reload('5d9b1c48', component.options)
    }
    module.hot.accept("./Dialog.vue?vue&type=template&id=5d9b1c48", function () {
      api.rerender('5d9b1c48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplySystem/supplyCentreSyntheticalManagement/supplyCentreList/components/Dialog.vue"
export default component.exports